import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

// -- Types ----------------------------------------------------------------------------------------

// -- Hook -----------------------------------------------------------------------------------------
export function useSubscribeCandlestickChartCrosshair(t0) {
  const $ = _c(5);
  const {
    chart,
    initialized,
    containerRef
  } = t0;
  const [crosshairParams, setCrosshairParams] = useState(null);
  let t1;
  let t2;
  if ($[0] !== chart || $[1] !== containerRef || $[2] !== initialized) {
    t1 = () => {
      if (chart && initialized && containerRef.current) {
        chart.subscribeCrosshairMove(setCrosshairParams);
      }
      return () => {
        if (chart) {
          chart.unsubscribeCrosshairMove(setCrosshairParams);
          setCrosshairParams(null);
        }
      };
    };
    t2 = [chart, initialized, containerRef];
    $[0] = chart;
    $[1] = containerRef;
    $[2] = initialized;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return crosshairParams;
}